import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';

function CustomSwitch(props) {
    const { checked, onClick, label, icon } = props;
    const [checkedClass, setCheckedClass] = useState('');

    useEffect(() => {
        if (checked === null) {
            setCheckedClass('xwitch-null');
        } else if (checked) {
            setCheckedClass('xwitch-checked');
        } else {
            setCheckedClass('xwitch-unchecked');
        }
    }, [checked]);

    return (
        <div className={ 'xwitch ' + checkedClass} onClick={onClick}>
            { label ? <label>{label}</label> : <label>&nbsp;</label> }
            { icon &&  <i className={icon}/> }
        </div>
    );
}

CustomSwitch.propTypes = {
    checked: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
};

export default CustomSwitch;